import axios from "axios"
import { HEADER_FORM_DATA, HEADERS } from "../../../../../API/UrlAndPaths"
import store from "../../../../../Redux/store"
import { get_branch_settings_list, get_branch_settings_row_data_list, setExternalTocken } from "./BranchSettingsSlice"
import { setSubmitLoading } from "../../../../../Redux/Dashboard/mainDashBoardSlice"
import { errorSnackMsg, successSnackMsg } from "../../../../Custom Hooks/SnackkBarUtilities"

// VIEW ALL BRANCH SETTINGS
export const viewAllBranchSettingsAPICall=(body,setIsLoading)=>{
    setIsLoading !== undefined && setIsLoading(true);
    axios.post("settings/viewbranchsettings",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            store.dispatch(get_branch_settings_list({branchSettingsData:res.data}))
            setIsLoading !== undefined && setIsLoading(false);
        }
    })
    .catch((err)=>{
        store.dispatch(get_branch_settings_list({branchSettingsData:undefined}))
        setIsLoading !== undefined && setIsLoading(false);
    })
}
//to generate tocken for external use
export const ExternalTockenGenerateAPI = async (body) => {
    await axios.get("externalapi/generateToken", {
        params: body,
        headers: HEADERS.headers
    })
        .then((res) => {
            if (res.status === 200) {
              console.log(res.data);
              
                store.dispatch(setExternalTocken(res.data))
                // setShiftDetails(res.data)
            }
        })
        .catch((err) => {
            store.dispatch(setExternalTocken(undefined))
        })
}

// branch settings single view
export const branchSettingsSingleView=(body)=>{
   console.log('📡 Fetching branch settings from API...', body);
   store.dispatch(setSubmitLoading(true))
    axios.post("settings/viewUserbranchSettings",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            console.log('✅ Branch settings fetched, updating Redux:', {
                deliveryChargeMode: res.data?.deliveryChargeMode,
                deliveryCharge: res.data?.deliveryCharge,
                posDevicesCount: res.data?.posDevices?.length || 0
            });
            store.dispatch(get_branch_settings_row_data_list({branchSettingsSingleData:res.data}))
            store.dispatch(setExternalTocken(undefined))
            // Persist posDevices to localStorage for Token Display
            if (res.data?.posDevices && Array.isArray(res.data.posDevices)) {
                try {
                    window.localStorage.setItem('branchSettings.posDevices', JSON.stringify(res.data.posDevices));
                    console.log('💾 Saved', res.data.posDevices.length, 'POS devices to localStorage');
                } catch (e) {
                    console.warn('Failed to save posDevices to localStorage:', e);
                }
            }
            store.dispatch(setSubmitLoading(false))
        }
    })
    .catch((err)=>{
        console.error('❌ Failed to fetch branch settings:', err);
        store.dispatch(setSubmitLoading(false))
        store.dispatch(get_branch_settings_row_data_list({branchSettingsSingleData:undefined}))

    })
}
export const linkDeviceAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  store.dispatch(setSubmitLoading(true));
  try {
    const res = await axios.post("sendToWs/link-device", body, HEADERS);
    if (res.status === 200) {
      const qrRes = await axios.get(`sendToWs/get-qr/${body.userId}`, HEADERS);
      store.dispatch(setSubmitLoading(false));
      setLoading && setLoading(false);
      return qrRes.data; 
        
      } else {
        store.dispatch(setSubmitLoading(false));
        setLoading && setLoading(false);
        return undefined;
      }
    
  } catch (err) {
    store.dispatch(setSubmitLoading(false));
    setLoading && setLoading(false);
    return undefined;
  }
}
export const WhatsappLogoutAPI = async (body, setLoading) => {
  setLoading && setLoading(true);
  store.dispatch(setSubmitLoading(true));
  try {
    const res = await axios.post("sendToWs/logout", body, HEADERS);
    if (res.status === 200) {
        store.dispatch(setSubmitLoading(false));
        setLoading && setLoading(false);
        return res.data; 
        }
    
  } catch (err) {
    store.dispatch(setSubmitLoading(false));
    setLoading && setLoading(false);
    return undefined;
  }
}
// export const linkDeviceAPI = (body,setLoading) => {
//      setLoading!== undefined && setLoading(true);
//     store.dispatch(setSubmitLoading(true));
//     return axios.post("sendToWs/link-device", body, HEADERS)
//         .then((res) => {
//             if (res.status === 200) {
//                 store.dispatch(setSubmitLoading(false));
//                 console.log(res.data);
//                 return res.data;
//             }
//             setLoading !== undefined && setLoading(false);
//         })
//         .catch((err) => {
//             store.dispatch(setSubmitLoading(false));
//             setLoading !== undefined && setLoading(false);
//             // Optionally handle error here
//             return undefined;
//         });
// };

// export const getQrCodeAPI = (userId,setLoading) => {
//     setLoading!== undefined && setLoading(true);
//     store.dispatch(setSubmitLoading(true));
//     return axios.get(`sendToWs/get-qr/${userId}`, HEADERS)
//         .then((res) => {
//             if (res.status === 200) {
//                 store.dispatch(setSubmitLoading(false));
//                 console.log(res.data);
//                 return res.data;
//             }
//             setLoading !== undefined && setLoading(false);
//         })
//         .catch((err) => {
//             store.dispatch(setSubmitLoading(false));
//             setLoading !== undefined && setLoading(false);
//             // Optionally handle error here
//             return undefined;
//         });
// };

export const sendWhatsAppMessageAPI=async(body,setStatus,setLoading)=>{
    setLoading && setLoading(true);
    try {
        const res = await axios.post("sendToWs/send-message", body, HEADERS);
        setLoading && setLoading(false);
        if(res.status===200){
            console.log(res.data);
            successSnackMsg(res.data.message)
            setStatus && setStatus("Message sent successfully!");
        }
    } catch (err) {
        console.log(err.response);
        errorSnackMsg(err.response || "Failed to send message");
        setStatus && setStatus("Failed to send message");
        setLoading && setLoading(false);
    }
}
export const sendWhatsAppMessageAPIDashboard = (body) => {
    console.log("Sending WhatsApp message with body:", body);
  return new Promise((resolve, reject) => {
    axios.post("sendToWs/send-message", body, HEADER_FORM_DATA)
      .then(res => {
        if (res.status === 200) {
          successSnackMsg(res.data.message);
          resolve({
            status: "success",
            message: res.data.message,
            data: res.data
          });
        } else {
          errorSnackMsg(res.data?.message || "Failed to send message");
          reject({
            status: "error",
            message: res.data?.message || "Failed to send message"
          });
        }
      })
      .catch(err => {
        console.error("WhatsApp API error:", err.response || err);
        errorSnackMsg(err.response?.data?.message || "Failed to send message");
        reject({
          status: "error",
          message: err.response?.data?.message || "Failed to send message"
        });
      });
  });
};